import PropTypes from "prop-types"
import { capitalize } from "humanize-plus"
import classnames from "classnames"
import Spinner from "shared/components/spinner"
import parse from "html-react-parser"

import checkSVG from "images/components/check2.svg?raw"
import styles from "./applet_configuration.module.scss"

const CollapsedConfigItem = ({
  type,
  title = "",
  status,
  index,
  onRemoveClick,
  onUpdateViewClick,
  appletUpdating,
}) => (
  <div className={styles.feature}>
    <span className={styles["feature-title-group"]}>
      {status === "validating" ? (
        <Spinner
          config={{
            left: "-5.3em",
            bottom: "0%",
            length: 3,
            width: 3,
            radius: 10,
            corners: 0,
            scale: 0.55,
            position: "relative",
          }}
        />
      ) : (
        <span
          className={classnames(styles["validation-status"], {
            [styles.dirty]: status === "dirty",
          })}
        >
          {status == "valid" ? parse(checkSVG) : "!"}
        </span>
      )}
      <div>
        <span className={styles["feature-index"]}>
          {capitalize(type)} {index}
        </span>
        <span className={styles["feature-title"]}>{title}</span>
      </div>
    </span>
    <span className={styles["feature-button-group"]}>
      <button
        className="button-tertiary button-outlined"
        type="button"
        onClick={() => onUpdateViewClick(true)}
        disabled={appletUpdating}
      >
        Configure
      </button>
      <a
        className={styles["remove-config"]}
        onClick={e =>
          confirm(`Are you sure you want to remove this ${type}?`) &&
          onRemoveClick(e)
        }
        data-open-in-current-window={true}
      >
        Remove
      </a>
    </span>
  </div>
)

CollapsedConfigItem.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  status: PropTypes.oneOf(["valid", "dirty", "validating"]),
  index: PropTypes.number.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onUpdateViewClick: PropTypes.func.isRequired,
  appletUpdating: PropTypes.bool.isRequired,
}

CollapsedConfigItem.defaultProps = {
  appletUpdating: false,
}

export default CollapsedConfigItem
